export default __webpack_public_path__ + "static/imx_chain_logo-0a05e530a9a4e7a6dd7df281a99b60f4.jpg";